import { FacebookPixel } from '../FacebookPixel';

export const sendPixelSingUpComplete = () => {
  FacebookPixel.trackCustom('CompleteRegistration');
};
